// extracted by mini-css-extract-plugin
export default {"customModal":"styles_customModal__AROrg","actionHeader":"styles_actionHeader__a5KH-"};